module.exports = __webpack_public_path__ + "static/bfp_slide_film-03958e737b8f930f42c0c703bb3d0867.jpg";